import * as Chatra from "@chatra/chatra";
import {
  BOT_RESET_RESPONSE,
  BOT_TYPE,
} from "constants/chatbotResponse.consants";
import useTimeoutCleanup from "hooks/useTimeoutCleanup";

/**
 *
 * @returns restartChat <- A function that checks the msg and determines if it needs to restart the chatra widget
 */
export default function useChatbot() {
  // get cleanTimeout from the useTimeoutCleanup hook
  const { cleanTimeout } = useTimeoutCleanup();

  /**
   *
   * @param msg
   * msg is an object that contains data about the response.
   * Example: bot: "Great to hear that worked!"
   * The object would look like this: {type: bot, text: "Great to hear that worked!"}
   * @param type is who is sending the message
   * @param text is wthe content in the message
   *
   */
  const restartChat = (msg: { text: string; type: string }) => {
    // If the message text is the same as the bot reset response and is sent from the bot and not the user:
    if (msg.text === BOT_RESET_RESPONSE && msg.type === BOT_TYPE) {
      // Restart the Chatra widget which restarts the conversation. This is being done by the Chatra package
      Chatra("restart");
    }
  };

  /**
   * Chatra Config. For more info look at https://www.npmjs.com/package/@chatra/chatra  & https://chatra.com/help/api/#methods
   */
  const CHATRA_CONFIG = {
    /**
     * Set up is anything that should be done before loading up the Chatra widget
     */
    setup: {
      /**
       * On a new message, pass the message into the restartChat function.
       * CleanTimeout is for a delay of 500ms
       * @param message
       */
      onNewMessage: (message: { text: string; type: string }) => {
        cleanTimeout(() => restartChat(message), 500);
      },
      // Setting the button color to the TXT Blue
      colors: {
        buttonBg: "#008dde",
      },
      // Let it be on Widget mode
      mode: "widget",
      locale: {
        chat: {
          input: {
            // Determines what appears at the message input box when there is nothing typed
            placeholder: "Respond to the bot or send us a message!",
          },
        },
      },
    },
    // ID for Chatra
    ID: process.env.REACT_APP_CHATRA_ID,
  };

  /**
   * This functino initializes chatra with the CHATRA_CONFIG settings
   */
  const initializeChatra = () => {
    Chatra("init", CHATRA_CONFIG);
  };
  return { restartChat, initializeChatra };
}
